<template>
  <section class="page-container" v-if="compInfo">
     <main class="user-detail-popup">
       <div class="wrapper fx-col">
         <div class="user-wrapper-outer">
           <div class="wrapper-title">
             <span>회사정보</span>
             <button class="btn-save user-btn-bg" @click="userInfoUpdate">저장</button>
           </div>
           <div class="middle-wrap fx">
             <table>
               <tbody>
                 <tr class="content">
                   <td class="title">아이디</td>
                   <td>
                     <span>{{ compInfo.siteId }}</span>
                   </td>
                 </tr>
                 <tr class="content">
                   <td class="title">도메인</td>
                   <td>
                     <input type="text" v-model="compInfo.siteDomain" />
                   </td>
                 </tr>
                 <!-- <tr class="content">
                   <td class="title">알</td>
                   <td>
                     <span>{{ numberWithCommas(compInfo.creditAmt) }}</span>
                   </td>
                 </tr>
                 <tr class="content">
                   <td class="title">알 서브포인트</td>
                   <td>
                     <span>{{ numberWithCommas(compInfo.creditSubPoint) }}</span>
                   </td>
                 </tr>
                 <tr class="content">
                   <td class="title">하위 컴퍼니 수</td>
                   <td>
                     <span>{{ numberWithCommas(compInfo.totalCompanyCnt) }}</span>
                   </td>
                 </tr> -->
               </tbody>
             </table>
             <div class="table-div-line"></div>
             <table class="date-table">
               <tbody>
                 <!-- <tr class="content">
                   <td class="title">회사등급</td>
                   <td>
                     <span>{{ $t(compInfo.partnerType) }}</span>
                   </td>
                 </tr> -->
                 <tr class="content">
                   <td class="title">회사명</td>
                   <td>
                     <input type="text" v-model="compInfo.siteName" />
                   </td>
                 </tr>
                 <!-- <tr class="content">
                   <td class="title">보험금</td>
                   <td>
                     <span>{{ numberWithCommas(compInfo.insuredAmt) }}</span>
                   </td>
                 </tr>
                 <tr class="content">
                   <td class="title">보험 서브포인트</td>
                   <td>
                     <span>{{ numberWithCommas(compInfo.insuredSubPoint) }}</span>
                   </td>
                 </tr> -->
                 <tr class="content">
                   <td class="title">총 회원 수</td>
                   <td>
                     <span>{{ numberWithCommas(compInfo.totalMemCnt) }}</span>
                   </td>
                 </tr>
               </tbody>
             </table>
           </div>
           <div class="middle-wrap fx">
             <table>
               <tbody>
                 <tr class="content">
                   <td class="title">비밀번호</td>
                   <td>
                     <input type="password" v-model="compInfo.memPass" />
                   </td>
                 </tr>
                 <tr class="content">
                   <td class="title">컴퍼니 제한수</td>
                   <td>
                     <input type="number" v-model="compInfo.compCountLimit" />
                   </td>
                 </tr>
                 <tr class="content">
                   <td class="title">컴퍼니 코드</td>
                   <td>
                     Qa2er8k96
                   </td>
                 </tr>
                 <!-- <tr class="content">
                   <td class="title">넥서스 전용</td>
                   <td>
                     <em v-if="compInfo.isOnlyNexus === 'Y'" class="onlyBtn">넥서스전용</em>
                     <button class="user-btn-bg" @click="getNexusOnly()">변환하기</button>
                   </td>
                 </tr> -->
               </tbody>
             </table>
             <div class="table-div-line"></div>
             <table class="date-table">
               <tbody>
                 <tr class="content">
                   <td class="title">비밀번호 확인</td>
                   <td>
                     <input type="password" v-model="memPassChk" />
                   </td>
                 </tr>
                 <tr class="content">
                   <td class="title">회원 제한수</td>
                   <td>
                     <input type="number" v-model="compInfo.userCountLimit" />
                   </td>
                 </tr>
                 <tr class="content">
                   <td class="title">트리플 연결 아이디</td>
                   <td>
                     <input type="text" v-model="compInfo.clientId"/>
                   </td>
                 </tr>
                 <tr class="content">
                   <td class="title">트리플 연동 키</td>
                   <td>
                     <input type="text" v-model="compInfo.clientSecretKey"/>
                     <button class="btn-save user-btn-bg" @click="tripleConnect">연동하기</button>
                   </td>
                 </tr>
               </tbody>
             </table>
           </div>
         </div>
         <div class="user-wrapper-outer" style="flex: 0">
           <div class="wrapper-title">
             <span>기능 설정</span>
             <button class="btn-save user-btn-bg" @click="siteOptionSave">저장</button>
           </div>
           <div class="middle-wrap set">
             <table>
               <tbody>
                 <tr class="content">
                   <td class="title">입금 가능</td>
                   <td class="td-toggle">
                     <div class="toggle-wrap">
                       <input type="checkbox" class="set-switch" @click="switchToggle" v-model="siteOption.cashInYn" />
                     </div>
                   </td>
                 </tr>
               </tbody>
             </table>
             <div class="table-div-line"></div>
             <table class="date-table">
               <tbody>
                 <tr class="content">
                   <td class="title">출금 가능</td>
                   <td class="td-toggle">
                     <div class="toggle-wrap">
                       <input type="checkbox" class="set-switch" @click="switchToggle" v-model="siteOption.cashOutYn" />
                     </div>
                   </td>
                 </tr>
               </tbody>
             </table>
             <div class="table-div-line"></div>
             <table class="date-table">
               <tbody>
                 <tr class="content">
                   <td class="title">베팅 가능</td>
                   <td class="td-toggle">
                     <div class="toggle-wrap">
                       <input type="checkbox" class="set-switch" @click="switchToggle" v-model="siteOption.betYn" />
                     </div>
                   </td>
                 </tr>
               </tbody>
             </table>
             <div class="table-div-line"></div>
             <table class="date-table">
               <tbody>
                 <tr class="content">
                   <td class="title">유저가입통제</td>
                   <td class="td-toggle">
                     <div class="toggle-wrap">
                       <input type="checkbox" class="set-switch" @click="switchToggle" v-model="siteOption.signupYn" />
                     </div>
                   </td>
                 </tr>
               </tbody>
             </table>
             <div class="table-div-line"></div>
             <table class="date-table">
               <tbody>
                 <tr class="content">
                   <td class="title">사이트 운전</td>
                   <td class="td-toggle">
                     <div class="toggle-wrap">
                       <input type="checkbox" class="set-switch" @click="switchToggle" v-model="siteOption.siteStatusYn" />
                     </div>
                   </td>
                 </tr>
               </tbody>
             </table>
           </div>
           <div class="cateWrap">
              <span>결제수단</span>
              <div class="cate">
                 <div class="toggle-wrap">
                   <span>일반화폐</span>
                   <input type="checkbox" class="set-switch"  @click="switchToggle" v-model="siteOption.payGCurrency" />
                 </div>
                 <div class="toggle-wrap">
                   <span>가상화폐</span>
                   <input type="checkbox" class="set-switch" @click="switchToggle" v-model="siteOption.payVCurrency" />
                 </div>
              </div>
           </div>
         </div>
         <div class="user-wrapper-outer">
           <div class="wrapper-title">
             <span>회사통계</span>
           </div>
           <div class="middle-wrap fx">
             <table>
               <tbody>
                 <tr class="content">
                   <td class="title">총 캐시</td>
                   <td>
                     <span>{{ numberWithCommas(compStats.totalCashAmt) }}</span>
                   </td>
                 </tr>
                 <tr class="content">
                   <td class="title">총 입금</td>
                   <td>
                     <span>{{ numberWithCommas(compStats.totalCashInAmt) }}</span>
                   </td>
                 </tr>
                 <tr class="content">
                   <td class="title">총 게임머니</td>
                   <td>
                     <span>{{ numberWithCommas(compStats.totalGameMoney) }}</span>
                   </td>
                 </tr>
                 <tr class="content">
                   <td class="title">총 베팅금</td>
                   <td>
                     <span>{{ numberWithCommas(compStats.totalWlAmt) }}</span>
                   </td>
                 </tr>
               </tbody>
             </table>
             <div class="table-div-line"></div>
             <table class="date-table">
               <tbody>
                 <tr class="content">
                   <td class="title"></td>
                   <td></td>
                 </tr>
                 <tr class="content">
                   <td class="title">총 출금</td>
                   <td>
                     <span>{{ numberWithCommas(compStats.totalCashOutAmt) }}</span>
                   </td>
                 </tr>
                 <tr class="content">
                   <td class="title">총 포인트</td>
                   <td>
                     <span>{{ numberWithCommas(compStats.totalPointAmt) }}</span>
                   </td>
                 </tr>
                 <tr class="content">
                   <td class="title">총 윈루즈</td>
                   <td>
                     <span>{{ numberWithCommas(compStats.totalWlAmt) }}</span>
                   </td>
                 </tr>
               </tbody>
             </table>
           </div>
         </div>
         <div class="user-wrapper-outer user-memo-wrap">
           <div class="wrapper-title">
             <span>메모</span>
             <button class="btn-save user-btn-bg" @click="userMemoUpdate">저장</button>
           </div>
           <div class="content">
             <textarea id="accessDesc" name="accessDesc" v-model="compInfo.memo"></textarea>
           </div>
         </div>
       </div>
       <div class="wrapper fx-col">
          <!-- <div class="user-wrapper-outer box-height-fit">
            <div class="wrapper-title">
              <span>상위컴퍼니 리스트</span>
            </div>
            <div class="middle-wrap">
              <div class="supComp-list-wrap">
                <template v-for="(item, idx) in topCompList" :key="item.siteId">
                  <span :class="compInfo.memId === item.siteId ? 'compColor-target' : 'compColor' + idx">{{ item.siteId }}</span>
                </template>
              </div>
            </div>
          </div> -->
          <!-- <div class="user-wrapper-outer">
            <div class="wrapper-title">
              <span>하위컴퍼니 리스트</span>
            </div>
            <div class="middle-wrap">
              <div class="table-wrap">
                <table class="mainTable">
                  <thead>
                    <tr>
                      <th>회사명</th>
                      <th>아이디</th>
                      <th>회원등급</th>
                      <th>보유머니</th>
                      <th>보유포인트</th>
                      <th>생성일</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="botCompList.length !== 0">
                      <tr v-for="item in botCompList" :key="item.siteId">
                        <td>
                          <button type="button" class="btn-link fc-green" @click="detailOpen('company', item.siteId)">{{ item.memName }}</button>
                        </td>
                        <td>
                          <button type="button" class="btn-link" @click="detailOpen('company', item.siteId)">{{ item.siteId }}</button>
                        </td>
                        <td>{{ $t(item.partnerType) }}</td>
                        <td>{{ numberWithCommas(item.totalMemCash) }}</td>
                        <td>{{ numberWithCommas(item.totalMemPoint) }}</td>
                        <td>{{ replceDateT(item.redDt) }}</td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="6">데이터가 없습니다.</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div> -->
          <div class="user-wrapper-outer s-content-container">
             <div class="wrapper-title">
               <div class="subWrap fx vt-c gap-10">
                 <span>OTP관리</span>
               </div>
             </div>
             <div class="wrapper-contents s-content-wrap otpToggle">
              <table>
                <colgroup>
                  <col style="width:20%">
                  <col style="width:20%">
                  <col style="width:30%">
                  <col style="width:30%">
                </colgroup>
                <thead>
                  <tr>
                    <th>아이디</th>
                    <th>OTP 사용여부</th>
                    <th>OTP 생성</th>
                    <th>QR CODE 확인</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="otpUseList.length > 0">
                    <template v-for="item in otpUseList" :key="item.adminId">
                      <tr>
                        <td>{{item.adminId}}</td>
                        <td><input type="checkbox" class="set-switch" @click="switchToggleOtp(item)" v-model="item.adminOtp" :class="{'on': item.adminOtp, 'off': !item.adminOtp}"/></td>
                        <td><button type="button" @click="makeOtp(item.adminId)">OTP생성</button></td>
                        <td><button type="button" @click="getQRData(item.adminId)">QR CODE 확인</button></td>
                      </tr>
                    </template>

                  </template>

                </tbody>
              </table>
              <div class="otpQr" v-if="otpQr">
                <h4>QR 생성<a @click="otpQr=!otpQr">닫기</a></h4>
                <div class="otpUrl">
                  <!-- {{ otpUrl }} -->
                  <a :href="otpUrl" target="_blank">{{ otpUrl }}</a>
                </div>
              </div>
             </div>
          </div>

         <div class="tab-container">
           <!-- <div class="tab-wrap">
             <input type="radio" id="amt_tab_1" name="amt_check" v-model="btnGroup" value="pt" />
             <label for="amt_tab_1">알설정</label>
             <input type="radio" id="amt_tab_2" name="amt_check" v-model="btnGroup" value="insure" />
             <label for="amt_tab_2">보험금설정</label>
             <a class="skin" @click="details('skin', compInfo.siteId)">스킨설정</a>
           </div> -->
           <div class="tab-body">
             <div class="btn-group" v-if="btnGroup === 'pt'">
               <!--button class="user-btn-bg" type="button">알 지급내역</button>
               <button class="user-btn-bg" type="button">알 환전내역</button-->
               <!-- <button class="user-btn-bg" type="button" @click="cashInModal.active = !cashInModal.active">알지급</button>
               <button class="user-btn-bg" type="button" @click="cashOutModal.active = !cashOutModal.active">알회수</button>
               <button class="user-btn-bg" type="button" @click="subpointInModal.active = !subpointInModal.active">서브포인트 지급</button>
               <button class="user-btn-bg" type="button" @click="subpointOutModal.active = !subpointOutModal.active">서브포인트 회수</button> -->
             </div>
             <div class="btn-group" v-if="btnGroup === 'insure'">
               <button class="user-btn-bg" type="button" @click="cashInModal.active = !cashInModal.active">보험금 지급</button>
               <button class="user-btn-bg" type="button" @click="cashOutModal.active = !cashOutModal.active">보험금 회수</button>
               <button class="user-btn-bg" type="button" @click="subpointInModal.active = !subpointInModal.active">서브포인트 지급</button>
               <button class="user-btn-bg" type="button" @click="subpointOutModal.active = !subpointOutModal.active">서브포인트 회수</button>
             </div>
           </div>

           <div class="btn-group mt-10">
             <button class="user-btn-bg" @click="details('gameBet', compInfo.siteId)">게임별 베팅설정</button>
             <button class="user-btn-bg" @click="details('gameRate', compInfo.siteId)">게임별 요율설정</button>
             <button class="user-btn-bg" @click="details('gameList', compInfo.siteId)">사용게임목록</button>
             <button class="user-btn-bg" @click="details('gameUi', compInfo.siteId)">기능사용여부(UI)</button>
           </div>

           <div class="btn-group mt-10">
             <input type="text" name="" placeholder="제외할 아이디" v-model="resetMemIds">
             <button class="user-btn-bg" @click="siteReset">사이트 초기화</button>
           </div>

           <div class="btn-group mt-10">
             <textarea placeholder="예)삭제할 회원아이디 : test12,test34,test56" v-model="deleteMemIdList" :disabled="deletingMembers"></textarea>
             <button class="user-btn-bg h55" :disabled="deletingMembers" @click="removeMem">{{ deletingMembers ? '삭제 처리 중...' : '회원삭제' }}</button>
           </div>
           <p v-if="deleteMemberMessage" class="mt-10" role="status" aria-live="polite">{{ deleteMemberMessage }}</p>
         </div>

       </div>
       <div class="modalWrap" v-if="cashInModal.active"> <!--알 지급, 지급 모달-->
         <div class="modal-item">
           <article class="modal-title">
             <sub-title :text="`알지급`" />
             <button class="btn-link modal-close" type="button" @click="inCashModalClose">
               <i class="fas fa-times"></i>
             </button>
           </article>
           <article class="fx-item-auto inputWrap">
             <input type="number" v-model="cashInModal.reqData.creditAmt" class="amtbox"/>

             <div class="btn-wrap">
               <button class="btn-layout btn-blue" type="button" @click="cashApply('in', compInfo.siteId)">지급</button>
             </div>
           </article>
         </div>
       </div>
       <div class="modalWrap" v-if="subpointInModal.active"> <!--알 지급, 지급 모달-->
         <div class="modal-item">
           <article class="modal-title">
             <sub-title :text="`서브포인트 지급`" />
             <button class="btn-link modal-close" type="button" @click="inPointModalClose">
               <i class="fas fa-times"></i>
             </button>
           </article>
           <article class="fx-item-auto inputWrap">
             <input type="number" v-model="subpointInModal.reqData.creditPointAmt" class="amtbox"/>

             <div class="btn-wrap">
               <button class="btn-layout btn-blue" type="button" @click="pointApply('in', compInfo.siteId)">지급</button>
             </div>
           </article>
         </div>
       </div>
       <div class="modalWrap" v-if="cashOutModal.active"> <!--알 회수, 회수 모달-->
         <div class="modal-item">
           <article class="modal-title">
             <sub-title :text="`알회수`" />
             <button class="btn-link modal-close" type="button" @click="outCashModalClose">
               <i class="fas fa-times"></i>
             </button>
           </article>
           <article class="fx-item-auto inputWrap">
             <!-- <div>금액</div> -->
             <input type="number" v-model="cashOutModal.reqData.creditAmt" class="amtbox"/>
             <div class="btn-wrap">
               <button class="btn-layout btn-blue" type="button" @click="cashApply('out', compInfo.siteId)">회수</button>
             </div>
           </article>
         </div>
       </div>
       <div class="modalWrap" v-if="subpointOutModal.active"> <!--알 지급, 지급 모달-->
         <div class="modal-item">
           <article class="modal-title">
             <sub-title :text="`서브포인트 회수`" />
             <button class="btn-link modal-close" type="button" @click="outPointModalClose">
               <i class="fas fa-times"></i>
             </button>
           </article>
           <article class="fx-item-auto inputWrap">
             <input type="number" v-model="subpointOutModal.reqData.creditPointAmt" class="amtbox"/>

             <div class="btn-wrap">
               <button class="btn-layout btn-blue" type="button" @click="pointApply('out', compInfo.siteId)">회수</button>
             </div>
           </article>
         </div>
       </div>
     </main>
  </section>

</template>

<script>
import lodash from "lodash";
import { getCode } from "@/api/utils";
import {
  companyDetail,
  companyTree,
  companyOption,
  companyOptionSave,
  createOtp,
  getQRCode,
  saveGameBet,
  saveGameRate,
  saveMenu,
  saveSuperGame,
  getVendorRating,
  setVendorRating,
  setSiteReset,
  tripleConnectionApi, getOtpUseList,
  flexInfo, nexusInfo
} from "@/api/company";
import {memberDelete, memberRateUpdata} from "@/api/user";
import { partnerModify } from "@/api/partner";
import { GAME_INFO_LIST } from "@/libs/constants.js";
import subTitle from "@/components/main/PageSubTitle";
import {apiUpdateOtpUseYn} from "@/api/otp";
import {mapState} from "vuex";
import {cashIn, cashOut, subPointIn, subPointOut} from "@/api/credit";

export default {
  name: "CompanyDetail",
  components: {
    subTitle
  },
  data() {
    return {
      compStats: {},
      topCompList: [],
      botCompList: [],
      otpQr: false,
      gameBet: false,
      otpUrl: '',
      btnGroup: "pt",
      reqData: {
        memId: this.$route.query.id
      },
      subCompanyList: [],
      memPassChk: "",
      cashInModal: {
        active: false,
        text: "입금",
        reqData: {
          siteId: "",
          creditAmt: 0
        }
      },
      subpointInModal: {
        active: false,
        text: "지급",
        reqData: {
          siteId: "",
          creditPointAmt: 0
        }
      },
      subpointOutModal: {
        active: false,
        text: "회수",
        reqData: {
          siteId: "",
          creditPointAmt: 0
        }
      },
      detailInfo: {},
      siteOption: {},
      venderRate: {
        active: false,
      },
      cashOutModal: {
        active: false,
        text: "출금",
        reqData: {
          siteId: "",
          creditAmt: 0
        }
      },
      creditInModal: {
        active: false,
        text: "크레딧 지급",
        reqData: {
          siteId: "",
          bonusRollingYn: "N",
          outAmt: 0,
          memo: "",
          type: "N"
        }
      },
      creditOutModal: {
        active: false,
        text: "크레딧 회수",
        reqData: {
          siteId: "",
          bonusRollingYn: "N",
          outAmt: 0,
          memo: "",
          type: "N"
        }
      },
      rateList: [],
      userRate: [],
      gameList: [],
      menuList: [],
      vendorCompList: [],
      originRate: [],
      rateGroup: {
        etc1: "",
        etc2: ""
      },
      userData: {},
      compInfo: null,
      totalData: null,
      rateAll: '',
      currentTab: 'casino', // casino, slot
      targetSiteId: this.$route.query.id,
      list: {},
      topMemId: '',
      resetMemIds: '',
      tripleClientId: '',
      tripleClientSecretKey: '',
      otpUseList: [],
      deleteMemIdList: null,
      deletingMembers: false,
      deleteMemberMessage: ''
    };
  },
  watch: {
    cashInYn (value) {
      this.siteOption.cashInYn = value ? 'Y': 'N'
    },
    cashOutYn (value) {
      this.siteOption.cashOutYn = value ? 'Y': 'N'
    },
    betYn (value) {
      this.siteOption.betYn = value ? 'Y': 'N'
    },
    signupYn (value) {
      this.siteOption.signupYn = value ? 'Y': 'N'
    },
    siteStatusYn (value) {
      this.siteOption.siteStatusYn = value ? 'Y': 'N'
    }
  },
  methods: {
    async removeMem () {
      if (this.deletingMembers) return

      const memIds = (this.deleteMemIdList || '').replace(/\s/g, '').split(',').filter(Boolean)
      if (!memIds.length) {
        this.deleteMemberMessage = '삭제할 회원 아이디를 쉼표로 구분해서 입력해주세요.'
        alert(this.deleteMemberMessage)
        return
      }
      if (memIds.length > 10) {
        this.deleteMemberMessage = '회원삭제는 한 번에 최대 10명까지 가능합니다.'
        alert(this.deleteMemberMessage)
        return
      }
      const memIdsStr = memIds.join(',')
      if (!confirm(memIdsStr + ' 회원을 삭제하시겠습니까?')) return

      this.deletingMembers = true
      this.deleteMemberMessage = '회원 삭제 처리 중입니다. 완료 안내가 나올 때까지 기다려주세요.'
      try {
        const res = await memberDelete({
          siteId: this.siteOption.siteId,
          memIds: memIdsStr
        })
        if (res && (res.resultCode === '0' || res.resultCode === 0)) {
          this.deleteMemberMessage = '회원 삭제가 완료되었습니다.'
          this.deleteMemIdList = null
        } else if (res && res.resultCode != null) {
          this.deleteMemberMessage = '회원 삭제에 실패했습니다. ' + (res.resultMessage || '관리자에게 문의해주세요.')
        } else {
          this.deleteMemberMessage = '삭제 결과를 확인할 수 없습니다. 회원 목록에서 삭제 여부를 확인해주세요.'
        }
      } catch (error) {
        this.deleteMemberMessage = '서버 응답을 확인하지 못했습니다. 회원 목록에서 삭제 여부를 확인한 후 다시 시도해주세요.'
      } finally {
        this.deletingMembers = false
      }
      alert(this.deleteMemberMessage)
    },
    bottomOtpList () {
      const params = {
        siteId: this.siteOption.siteId
      }
      getOtpUseList(params).then(res => {
        if (res.resultCode === '0') {
          this.otpUseList = res.data.adminOtpList
          this.otpUseList.forEach(item => {
            item.adminOtp = item.adminOtp === 'Y' ? true : false
          })
        }
      })
    },
    tripleConnect () {
      if (!this.compInfo.clientId) {
        alert('트리플 연결 아이디를 입력해주세요')
        return false
      }
      if (!this.compInfo.clientSecretKey) {
        alert('트리플 연동키를 입력해주세요')
        return false
      }
      const params = {
        siteId: this.reqData.memId,
        clientId: this.compInfo.clientId,
        clientSecretKey: this.compInfo.clientSecretKey
      }

      tripleConnectionApi(params).then(res => {
        const resultCode = res.resultCode
        if (resultCode === '0') {
          alert('연동이 완료되었습니다.')
        } else {
          alert('연동 실패 : ', res.resultMessage)
        }
      })
    },
    siteReset() {
        if (!confirm("입력한 아이디를 제외한 사이트모든 정보가 초기화 됩니다. 진행하시겠습니까?. 시간이 오래걸릴수있습니다. 완료메세지 나올때까지 대기해주세요.")) {
          alert("진행을 취소하였습니다.")
        } else{
          let memIds = this.resetMemIds
          if (memIds) {
            memIds = memIds.replace(/\s/g, '')
            const params = {
              siteId: this.reqData.memId,
              memIds: memIds
            }

            setSiteReset(params).then(res => {
              const resultCode = res.resultCode
              if (resultCode === '0') {
                alert('정상적으로 초기화 되었습니다.')
              } else {
                alert(res.resultMessage)
              }
            })
          } else {
            alert('제외할 아이디를 입력해주세요')
          }
      }
    },
    details(type, targetId) {
      const name = type;
      const routeData = this.$router.resolve({ name: name, query: { id: targetId } });
      window.open(routeData.href, "newpage", "top=0,left=150,scrollbars=no,resizable=no,width=1455,height=825,status=no");
    },
    openInNewTab(url) {
      window.open(url, '_blank', 'noreferrer');
    },
    superGameUpdate () {
      const gameSettingInfoList = []
      for (let i = 0; i < this.gameList.length; i++) {
        const item = this.gameList[i]
        gameSettingInfoList.push({
          groupCode: item.groupCode,
          code: item.code,
          apiVendor: item.apiVendor,
          superUseYn: item.superUseYn
        })
      }
      const params = {
        siteId: this.compInfo.siteId,
        topCompId: this.compInfo.topCompId,
        gameSettingInfoList: gameSettingInfoList
      }
      saveSuperGame(params).then(res => {
        if(res.resultCode === '0') {
          alert('사용 게임  설정 저장 완료')
          this.getCompanyDetail()
        }
      })
    },
    menuUpdate () {
      const menuSettingList = []
      for (let i = 0; i < this.menuList.length; i++) {
        const item = this.menuList[i]
        menuSettingList.push({
          menuGroupCode: item.menuGroupCode,
          menuCode: item.menuCode,
          useYn: item.useYn
        })
      }

      const params = {
        siteId: this.compInfo.siteId,
        topCompId: this.compInfo.topCompId,
        menuSettingList: menuSettingList
      }
      saveMenu(params).then(res => {
        if(res.resultCode === '0') {
          this.rateAll = ''
          alert('기능 사용여부 설정 저장 완료')
          this.getCompanyDetail()
        }
      })
    },
    gameRateUpdate () {
      const gameSettingInfoList = []
      for (let i = 0; i < this.gameList.length; i++) {
        const item = this.gameList[i]
        gameSettingInfoList.push({
          code: item.code,
          pointRate: item.pointRate
        })
      }

      const params = {
        siteId: this.compInfo.siteId,
        topCompId: this.compInfo.topCompId,
        gameSettingInfoList: gameSettingInfoList
      }
      saveGameRate(params).then(res => {
        if(res.resultCode === '0') {
          this.rateAll = ''
          alert('게임 요율 설정 저장 완료')
          this.getCompanyDetail()
        }
      })

    },
    setRateAll () {
      if (this.rateAll.toString() !== '') {
        for (let i = 0; i < this.gameList.length; i++) {
          const item = this.gameList[i]
          item.pointRate = this.rateAll.toString()
        }
      }
    },
    gameRateReload () {
      this.gameList = JSON.parse(JSON.stringify(this.totalData.gameList))
      for (let i = 0; i < this.gameList.length; i++) {
        const item = this.gameList[i]
        item.isBet = item.compBetYn === 'Y' ? true : false
      }
    },
    gameBetUpdate () {
      const gameSettingInfoList = []
      for (let i = 0; i < this.gameList.length; i++) {
        const item = this.gameList[i]
        gameSettingInfoList.push({
          groupCode: item.groupCode,
          code: item.code,
          compBetYn: item.compBetYn
        })
      }

      const params = {
        siteId: this.compInfo.siteId,
        topCompId: this.compInfo.topCompId,
        gameSettingInfoList: gameSettingInfoList
      }
      saveGameBet(params).then(res => {
        if(res.resultCode === '0') {
          alert('게임 베팅 설정 저장 완료')
          this.getCompanyDetail()
        }
      })

    },
    setGameBetAll (value) {
      for (let i = 0; i < this.gameList.length; i++) {
        const item = this.gameList[i]
        item.compBetYn = value ? 'Y' : 'N'
        item.isBet = value
      }
    },
    gameListReload () {
      this.gameList = JSON.parse(JSON.stringify(this.totalData.gameList))
      for (let i = 0; i < this.gameList.length; i++) {
        const item = this.gameList[i]
        item.isBet = item.compBetYn === 'Y' ? true : false
      }
    },
    makeOtp (adminId) {
      const param = {
        siteId: this.compInfo.siteId,
        adminId: adminId
      }
      createOtp(param).then(res => {
        if(res.resultCode === '0') {
           if (!confirm( 'OTP를 새로 발급하시겠습니까? 이미발급된 링크는 더이상 사용하실수없습니다')) {
             alert('취소를 누르셨습니다.')
          } else {
             setTimeout(()=>{
                this.otpQr = true
                this.otpUrl = res.data.otpUrl
             },1000)
          }
        }
      })
    },
    getQRData (adminId) {
      const param = {
        siteId: this.compInfo.siteId,
        adminId: adminId
      }
      getQRCode(param).then(res => {
        if(res.resultCode === '0') {
          setTimeout(()=>{
            this.otpQr = true
            this.otpUrl = res.data.otpUrl
          },1000)

        }
      })
    },
    async _memLogout(siteId) {
      const reqData = {
        siteId: siteId
      };
      const res = await memLogout(reqData);
      if (res.resultCode === "0") {
        alert("로그아웃 처리 완료");
      } else {
        alert("로그아웃 처리 실패");
      }
    },
    async cashApply(type, siteId) {
      let res = "";
      if (type === "in") {
        this.cashInModal.reqData.siteId = siteId;
        const param = {
          ...this.cashInModal.reqData,
          creditAmt: this.cashInModal.reqData.creditAmt.toString()
        }
        res = await cashIn(param);
        if (res.resultCode === "0") {
          alert("입금완료");
          this.getCompanyDetail();
          this.cashInModal.reqData.creditAmt = 0;
        } else {
          alert("입금실패, 다시 시도해주세요.");
        }
      } else if (type === "out") {
        if (this.compInfo.cashAmt < this.cashOutModal.reqData.creditAmt) {
          this.cashOutModal.reqData.creditAmt = 0;
          alert("출금액은 보유금액보다 적어야 합니다.");
          return;
        }
        this.cashOutModal.reqData.siteId = siteId;
        res = await cashOut(this.cashOutModal.reqData);
        if (res.resultCode === "0") {
          alert("출금완료");
          this.getCompanyDetail();
          this.cashOutModal.reqData.creditAmt = 0;
        } else {
          alert("출금실패, 다시 시도해주세요.");
        }
      }
    },
    async pointApply(type, siteId) {
      let res = "";
      if (type === "in") {
        this.subpointInModal.reqData.siteId = siteId;
        const param = {
          ...this.subpointInModal.reqData,
          creditPointAmt: this.subpointInModal.reqData.creditPointAmt.toString()
        }
        res = await subPointIn(param);
        if (res.resultCode === "0") {
          alert("지급 완료");
          this.subpointInModal.active = false
          this.getCompanyDetail();
          this.subpointInModal.reqData.creditPointAmt = 0;
        } else {
          alert("지급실패, 다시 시도해주세요.");
        }
      } else if (type === "out") {

        this.subpointOutModal.reqData.siteId = siteId;
        res = await subPointOut(this.subpointOutModal.reqData);
        if (res.resultCode === "0") {
          alert("회수 완료");
          this.subpointOutModal.active = false
          this.getCompanyDetail();
          this.subpointOutModal.reqData.creditPointAmt = 0;
        } else {
          alert("회수 실패, 다시 시도해주세요.");
        }
      }
    },
    async userInfoUpdate() {
      const reqData = {
        siteId: this.compInfo.siteId,
        topCompId: this.compInfo.topCompId,
        password: this.compInfo.memPass,
        siteName: this.compInfo.siteName,
        userCountLimit: this.compInfo.userCountLimit,
        compCountLimit: this.compInfo.compCountLimit
      };
      const res = await partnerModify(reqData);
      if (res.resultCode === "0") {
        alert("회원정보수정 완료");
      } else {
        alert("회원정보 변경실패, 다시 시도해주세요.");
      }
    },
    async userMemoUpdate() {
      const reqData = {
        siteId: this.compInfo.siteId,
        topCompId: this.compInfo.topCompId,
        password: this.compInfo.memPass,
        memo: this.compInfo.memo
      };
      const res = await partnerModify(reqData);
      if (res.resultCode === "0") {
        alert("메모수정 완료");
      } else {
        alert("메모수정실패, 다시 시도해주세요.");
      }
    },
    parentLinkMove(linkTarget, siteId) {
      console.log("move");
      if (linkTarget === "/reports/totalList") {
        window.opener.location.href = `${linkTarget}?id=${siteId}`;
      } else {
        window.opener.location.href = `/user${linkTarget}?id=${siteId}`;
      }
    },
    async siteOptionSave() {
      const option = {
        siteId: this.compInfo.siteId,
        topCompId: this.compInfo.topCompId
      }
      const siteOption = JSON.parse(JSON.stringify(this.siteOption))
      delete siteOption['adminOtp']
      for (const key in siteOption) {
        if (typeof siteOption[key] === "boolean") {
          if (siteOption[key]) {
            siteOption[key] = "Y";
          } else {
            siteOption[key] = "N";
          }
        }
      }
      option['siteOption'] = siteOption
      const res = await companyOptionSave(option);
      if (res.resultCode === "0") {
        await this.getCompanyDetail();
        alert("설정 저장 완료");
      } else {
        alert("설정 저장 실패, 다시 시도해주세요.");
      }
    },
    async getCompanyTree() {
      const reqData = {
        siteId: this.reqData.memId,
        targetId: this.reqData.memId,
        searchType: "partner"
      };
      const res = await companyTree(reqData);
      const list = res.data.list;
      if (list) {
        this.compInfo.subCompanyCnt = list.length;
      } else {
        this.compInfo.subCompanyCnt = 0;
      }
      this.subCompanyList = list;
    },
    getNexusOnly() {
      const params = {
        siteId: this.compInfo.memId,
        isOnlyNexus: this.compInfo.isOnlyNexus
      }
      const confirmMessage = '넥서스 전용으로 변환됩니다. 계속 진행할까요?'
      nexusInfo(params).then(res => {
        if (res.resultCode === "0") {
          if (confirm(confirmMessage)) {
            this.compInfo.isOnlyNexus  = 'Y'
            alert('넥서스 전용으로 변경되었습니다.')
          } else {
            alert('넥서스 전용으로 변경에 실패했습니다.')
          }
        }
      })
    },
    switchToggle(event) {
      const toggle = event.target;
      const text = toggle.previousElementSibling;
      // console.log(toggle.checked)
      if (text) {
        if (toggle.checked) {
          text.classList.remove("off");
          text.classList.add("on");
        } else {
          text.classList.remove("on");
          text.classList.add("off");
        }
      }
    },
    async switchToggleOtp(item) {
      const adminId = item.adminId

      item.adminOtp = !item.adminOtp

      let useYn = ''
      if (item.adminOtp) {
        useYn = 'Y'
      } else {
        useYn = 'N'
      }

      await apiUpdateOtpUseYn({
        useYn,
        account: adminId || this.compInfo.siteId
      }).then(result => {
        if (result.resultCode === '0') {
          alert('변경이 완료되었습니다.')
        }
      })

    },
    async switchBottomToggleOtp(event, adminId) {
      const toggle = event.target;
      const text = toggle.previousElementSibling;
      // console.log(toggle.checked)
      let useYn = ''
      if (text) {
        if (toggle.checked) {
          text.classList.remove("off");
          text.classList.add("on");
          useYn = 'Y'
        } else {
          text.classList.remove("on");
          text.classList.add("off");
          useYn = 'N'
        }
      }

      await apiUpdateOtpUseYn({
        useYn,
        account: adminId
      }).then(result => {
        if (result.resultCode === '0') {
          alert('변경이 완료되었습니다.')
        }
      })

    },
    switchGame (item) {
      item.isBet = !item.isBet
      item.compBetYn = item.isBet ? 'Y': 'N'
    },
    switchSuperGame (item) {
      item.isSuperUse = !item.isSuperUse
      item.superUseYn = item.isSuperUse ? 'Y': 'N'
    },
    switchMenu (item) {
      item.isUse = !item.isUse
      item.useYn = item.isUse ? 'Y': 'N'
    },
    inCashModalClose() {
      this.cashInModal.active = !this.cashInModal.active;
    },
    outCashModalClose() {
      this.cashOutModal.active = !this.cashOutModal.active;
    },
    inPointModalClose() {
      this.subpointInModal.active = !this.subpointInModal.active;
    },
    outPointModalClose() {
      this.subpointOutModal.active = !this.subpointOutModal.active;
    },
    venderRateModalOpen() {
      this.loadData()
      this.venderRate.active = true;
      document.body.style.overflow = 'hidden';
    },
    venderRateModalClose() {
      this.venderRate.active = false;
      document.body.style.overflow = 'auto';
    },
    modalControl(siteId) {
      this.getCompanyDetail(siteId);
      this.modal.target = siteId;
      this.modal.active = !this.modal.active;
    },
    async getCompanyDetail() {
      const model = {
        memId: this.reqData.memId,
        siteId: this.reqData.memId
      };
      const res = await companyDetail(model);
      if (res.resultCode !== "0") {
        return;
      }
      this.totalData = JSON.parse(JSON.stringify(res.data))
      const compInfo = res.data.compInfo
      // const compStats = res.data.compStats

      if (compInfo) {
        this.compInfo = compInfo
      }
      // this.topCompList = res.data.topCompList
      // this.botCompList = res.data.botCompList
      this.gameList = res.data.gameList
      this.menuList = res.data.menuList

      this.vendorCompList = res.data.vendorCompList

      for (let i = 0; i < this.gameList.length; i++) {
        const item = this.gameList[i]
        item.isBet = item.compBetYn === 'Y' ? true : false
        item.isSuperUse = item.superUseYn === 'Y' ? true : false
      }

      const tempMenu = {}
      for (let i = 0; i < this.menuList.length; i++) {
        const item = this.menuList[i]

        if (!tempMenu[item.menuGroupCode]) {
          item.first = true
        }
        tempMenu[item.menuGroupCode] = '1'
        item.isUse = item.useYn === 'Y' ? true : false
      }

      // this.memberFlow = res.data.memberFlow;
      // this.partnerFlow = this.jsonSort(res.data.partnerFlow, "topOrder", "desc");
      // console.log(this.partnerFlow)
      if (this.compInfo.lastLoginDt) {
        this.compInfo.lastLoginDt = this.replceDateT(this.compInfo.lastLoginDt);
      }
      // this.compStats = {...compStats}
      for (const item in this.userData) {
        if (item.indexOf("Yn") !== -1 && item !== "memberCommissionRate") {
          if (this.userData[item] === "Y") {
            this.userData[item] = true;
          } else {
            this.userData[item] = false;
          }
        }
      }
      this.memPassChk = compInfo.memPass;

      const setting = res.data.settingInfo
      for (let key in setting) {
        if (setting[key] === 'Y') {
          this.siteOption[key] = true
        } else if(setting[key] === 'N') {
          this.siteOption[key] = false
        } else {
          this.siteOption[key] = setting[key]
        }
      }
    },
    getUserRate() {
      return memberRate(this.reqData);
    },
    getGameCode() {
      return getGameCodes("kplay");
    },
    setRateLoop(maxRate) {
      return maxRate / 0.05;
    },
    getMemLevel() {
      this.userData;
    },
    async setMemStatus() {
      const reqData = {
        siteId: this.compInfo.siteId,
        memStatus: this.compInfo.memStatus
      };
      try {
        const res = await memStatusChange(reqData);
        if (res.resultCode !== "0") {
          alert("회원상태 변경에 실패했습니다. 다시 시도해주세요.");
        } else {
          alert("회원상태 변경완료");
        }
      } catch (e) {
        console.log(e);
        alert("회원상태 변경에 실패했습니다. 다시 시도해주세요.");
      }
    },
    setRateList() {
      this.setRateListDefault();
      this.combineUserRate();
    },
    setRateListDefault() {
      // console.log(this.gameListDefault);
      for (const loop of this.gameListDefault) {
        for (const item of loop.child) {
          const model = lodash.cloneDeep(this.rateModel);
          model.gameType = item.code;
          model.gameName = item.codeName;
          model.groupCode = item.groupCode;
          model.loop = Number(model.maxPointRate) / this.rateIncrease;
          this.rateList.push(model);
        }
      }
      this.originRate = lodash.cloneDeep(this.rateList);
    },
    combineUserRate() {
      const rateList = lodash.cloneDeep(this.rateList);
      for (const loop of this.compInfo.memberCommissionRate) {
        rateList.forEach((target, index, arr) => {
          if (target.gameType === loop.gameType) {
            target.gameType.pointRate = loop.pointRate;
            target.gameType.maxPointRate = loop.maxPointRate;
            target.gameType.loop = Number(loop.maxPointRate) / this.rateIncrease;
            arr.splice(index, 1);
            return false;
          }
        });
      }
      this.originRate = rateList;
      this.rateList = rateList;
    },
    async afterSaveAndGetData () {
      const confirmMessage = '상위 벤더 회사(트리플A)에서 요율을 가져와서 저장합니다. 기존에 저장되어있는 데이더를 덮어쓰게 됩니다. 진행하시겠습니까?'
      if (confirm(confirmMessage)) {
        await setVendorRating({ siteId: this.targetSiteId }).then(async res => {
          if (res.resultCode === '0') {
            const result = res.data.list
            await this.dataProcessing(result)
            alert('저장이 완료되었습니다.')
          }
        })
      } else {
        return false
      }
    },
    async loadData () {
      await getVendorRating({ siteId: this.targetSiteId }).then(async res => {
        if (res.resultCode === '0') {
          const result = res.data.list
          await this.dataProcessing(result)
        }
      })
    },
    async dataProcessing (data) {
      const casinoList = data.filter(item => item.category === 'casino')
      const slotList = data.filter(item => item.category === 'slot')

      const casino = this.productGrouping(casinoList)
      const slot = this.productGrouping(slotList)

      this.list = {
        casino,
        slot
      }
    },
    productGrouping (list) {
      const grouping = {}
      list.forEach(item => {
        const productCode = item.productCode
        this.topMemId = item.topCompId

        if (!grouping[productCode]) {
          grouping[productCode] = {
            productCode,
            productName: item.productName,
            children: []
          }
        }
        grouping[productCode].children.push(item)
      })
      return grouping
    }
  },
  computed: {
    ...mapState([
      'siteData'
    ]),
    getTargetList () {
      return this.list[this.currentTab]
    }
  },
  async created() {
    this.emitter.emit('Loading', true)

    const memId = this.$route.query.id
    if(memId) {
      this.reqData.memId = memId
    }
    await this.getCompanyDetail();

    await this.setGameList();
    this.setRateListDefault();

    // await this.getCompanyTree();
    await this.bottomOtpList()
    this.emitter.emit('Loading', false)
    // await this.getCompanyOption();
  }
};
</script>

<style scoped>
.w100w {width: 100% !important;}
.w25w {width: 25% !important;}
.bl {color: #0d73ff;}
.ft10 {font-size: 10px !important;}
.fx {display: flex !important;justify-content: initial;}
.fx > table {width: 49% !important;}
.user-memo-wrap textarea {margin-bottom: 10px;}
.user-wrapper-outer {background: #fff;}
.user-wrapper-outer > .middle-wrap .content > .title:first-child {width: 120px;}
.user-wrapper-outer > .middle-wrap.menu {display: flex;justify-content: space-between;flex-wrap: wrap;}
.user-wrapper-outer > .middle-wrap.menu > table {float: none;margin-left: 15px;}
.user-wrapper-outer > .middle-wrap.menu > table.first {margin-left: 5px;}
.user-wrapper-outer > .middle-wrap.menu > table .content.first > .title {color: #0d73ff;}
.cateWrap {display: flex;align-items: center;margin: 0 20px 10px;width: 100%;}
.cateWrap > span {width: 100px;color: #18698b;font-weight: bold;}
.cate {display: flex;gap: 20px;}
.cate .toggle-wrap {gap: 10px;}
.active .btn-t-inner {
  display: none;
}
.fstColumn.userList .levelColor {
  display: block;
}

.box-hideOpen .levelColor {
  background: rgb(255, 218, 38);
  width: 8px;
}
.seletAndDelete {
  display: flex;
  align-items: center;
}
.msg-all-sel {
  margin-right: 4px !important;
  height: 30px;
  box-sizing: border-box;
}
#siteId {
  margin-right: 4px;
}
z .btn-state-change.cancle {
  margin-right: 4px;
}
.user-detail-popup {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  width: 1435px;
  gap: 15px;
  margin: 0;
  box-sizing: border-box;
}
.user-detail-popup select {
  font-size: 1em;
}
.wrapper-title .btn-other {
  height: 21px;
  padding: 0 10px;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 500;
  background-color: #126ae2;
}
.wrapper-title .btn-save {
  width: 42px;
  height: 21px;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 500;
  background-color: #126ae2;
}
.wrapper-title .btn-save:hover {
  color: #126ae2;
  background: #fff;
}
.button-wrap {
  display: flex;
}
.button-wrap > button {
  flex: 1;
  margin-right: 4px;
}
.button-wrap > button:last-child {
  margin-right: 0;
}
input[type="text"],
input[type="number"],
input[type="password"] {
  font-weight: 500;
  border: 1px solid #c5c5c5;
  height: 21px;
  padding: 0 6px;
  box-sizing: border-box;
  border-radius: 3px;
}
select {
  border: 1px solid #c5c5c5;
}
.userInfo-select {
  font-weight: 500;
  padding: 2px 5px;
  height: 21px;
  width: 100%;
}
.s-content > .content {
  display: flex;
  height: calc(56px - 26px);
}
.modal-item {
  width: 385px;
  min-width: 385px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: solid 1px #c1c1c1;
  box-shadow: 6px 6px 6px 0 rgba(0, 0, 0, 0.16);
  padding: 15px 25px;
  background: #fafafa;
  box-sizing: border-box;
}

.modalWrap .inputWrap {
  display: flex;
  flex-direction: column;
  padding: 10px 0 0;
  gap: 10px;
  justify-content: center;
}
.modalWrap .amtbox {
  display: block;
  width: 50%;
  height: 30px;
  margin: 0 auto;
}
.btn-wrap {margin-top: 18px;}
.modalWrap .btn-blue {
  width: 90px;
  height: 26px;
  border-radius: 2px;
  border: solid 1px #646464;
  box-sizing: border-box;
  background-color: #fafafa;
  font-size: 13px;
  color: #343434;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.modalWrap .btn-blue:hover {
  background-color: #646464;
  color: #fff;
}
.modal-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid #959595;
  padding-bottom: 11px;
}
.sub-title {
  height: auto;
  color: #646464;
  font-size: 13px;
  padding: 0;
}
.sub-title > h3 {
  width: fit-content;
}
.modal-close {
  font-size: 20px;
  color: #646464;
  position: relative;
  transform: none;
  top: auto;
  right: auto;
}
.table-wrap {
  width: 100%;
  overflow-y: scroll;
  max-height: 340px;
  margin-top: 20px;
}
.mainTable {
  font-size: 12px !important;
}
.mainTable th {
  height: 35px;
  /* background: var(--main); */
  background: #18698b;
  color: #fff;
  font-weight: 700;
  vertical-align: middle;
}

.supComp-list-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
span[class^="compColor"] {
  font-weight: bold;
}
span[class^="compColor"]:after {
  content: "▶";
  display: inline;
  margin-left: 5px;
}
span[class^="compColor"]:last-child:after {
  content: "";
}
.compColor-target {
  color: #d82beb;
}
.tab-container {
  width: 100%;
}
.tab-container .tab-wrap {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}
.tab-wrap > input {
  display: none;
}
.tab-wrap > input + label, .skin {
  flex: 1 1 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 44px;
  color: #8f8faa;
  border: 1px solid #8f8faa;
  font-size: 13px;
  cursor: pointer;
  font-weight: 500;
}
.tab-wrap > input:checked + label, .skin:hover {
  color: #27273f;
  background: #fff;
  font-weight: 700;
}
.btn-group input {width: 75%;height: 35px;}
.btn-group textarea {width: 75%;
    border: 1px solid #c5c5c5;
    padding: 6px;
    box-sizing: border-box;
    border-radius: 3px;
    line-height: 1.5em;
    font-size: 13px;
    resize: none;height: 55px;}
.h55 {height: 55px !important;}
.tab-container .btn-group {
  display: flex;
  width: 100%;
  gap: 5px;
}
.tab-container .btn-group button {
  flex: 1 1 16.5%;
  height: 35px;
  background-color: #126ae2;
  border: 0;
  font-size: 13px;
  color: #ffffff;
  font-weight: 500;
  border-radius: 0px;
}
.user-wrapper-outer > .middle-wrap .content > td {
  padding: 0;
}
.user-wrapper-outer .table-div-line {
  margin: 0 10px;
}
.wrapper-title {
  margin-bottom: 0;
}
.user-detail-popup .wrapper {
  gap: 15px;
}
.s-content-container {
  height: fit-content;
}
.s-content-wrap {
  overflow: visible;
  height: fit-content;
  max-height: unset;
  padding: 15px 0;
}
.s-content {
  display: flex;
  height: fit-content;
  border: 0;
  max-width: unset;
  flex-basis: unset;
  margin: 0;
  width: 23.1%;
  padding: 5px 0;
  box-sizing: border-box;
  justify-content: space-between;
}
.s-content .title {
  overflow: unset;
  display: flex;
  align-items: center;
  text-overflow: unset;
  background: #fff;
  font-size: 10px;
  color: #40405b;
  font-weight: 500;
  width: 110px;
  text-align: left;
  word-break: normal;
  white-space: pre-wrap;
  padding: 0;
}
.s-content-line {
  width: 1px;
  height: 40px;
  margin: 0 8px;
  background: #8f8faa;
}
.btn-reset {
  width: 19px;
  height: 19px;
  border-radius: 3px;
  background-color: #ffffff;
  border: 1px solid #e6e6f6;
  cursor: pointer;
}
.btn-settings {
  min-width: 53px;
  box-sizing: border-box;
  font-size: 10px;
  color: #126ae2;
  font-weight: 500;
  height: 21px;
  border-radius: 5px;
  background-color: #ffffff;
  border: 1px solid #126ae2;
  padding: 0 10px;
  cursor: pointer;
}
.btn-settings:hover {
  background-color: #126ae2;
  color: #fff;
}
.s-content input[type="text"] {
  width: 48px;
  height: 22px;
  background-color: #ffffff;
  border: 1px solid #e6e6f6;
  padding: 0;
  font-size: 10px;
  text-align: center;
}
.rateControl-all {
  width: 65px;
  height: 22px;
  background-color: #ffffff;
  border: 1px solid #e6e6f6;
  padding: 0;
  font-size: 10px;
  text-align: center;
}
.user-wrapper-outer > .middle-wrap{
  border-bottom:0;
  display: block;
}
.user-wrapper-outer > .middle-wrap > table {width: 20%;float: left;margin-bottom: 10px;}
.box-height-fit{
  height:fit-content !important;
  flex:0 !important;
}
.user-wrapper-outer > .middle-wrap.set {display: flex;}
.toggle-wrap {width: auto;}
.otpToggle {display: flex;align-items: center;gap: 15px;}
.otpToggle .use {display: flex;align-items: center;gap: 5px;}
.otpToggle .btn-group {display: flex;align-items: center;gap: 15px;}
.otpToggle .btn-group button {width: 110px;height: 35px;background-color: #fff;border: 1px solid #126ae2;border-radius: 5px;box-sizing: border-box;color: #126ae2;font-size: 13px;font-weight: 500;cursor: pointer;}
.otpToggle .btn-group button:hover {background-color: #126ae2;color: #fff;}
.s-content-wrap.otpToggle {
  padding: 0;
  padding-bottom: 10px;
  max-height: 210px;
  overflow-y: scroll;
}
.otpToggle table {
  width: 100%;
  text-align: center;
  box-sizing: border-box;
}
.otpToggle table th {
  padding: 10px 0;
  font-weight: bold;
  background: #18698b;
  border-top: 0;
  color: #fff;
}
.otpToggle table td {
  padding: 5px 0;
}
.otpToggle button {padding: 5px 8px;background-color: #fff;border: 1px solid #126ae2;border-radius: 5px;box-sizing: border-box;color: #126ae2;font-size: 13px;font-weight: 500;cursor: pointer;}
.otpToggle button:hover {background-color: #126ae2;color: #fff;}

.otpQr {position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);border: 1px solid #8f8faa;border-radius: 2px;background: #fff;width: 500px;padding: 13px;z-index: 1;text-align: center;}
.otpQr h4 {height: 42px;border-bottom: 1px solid #c5c5c5;display: flex;justify-content: space-between;align-items: center;font-size: 13px;color: #27273f;font-weight: 700;}
.otpQr h4 a {width: 42px;height: 21px;border-radius: 5px;font-size: 10px;font-weight: 500;background-color: #126ae2;color: #fff;display: flex;justify-content: center;align-items: center;cursor: pointer;}
.otpQr > img {width: 250px;margin: 15px 0;}
.otpQr > div {
  padding: 10px;
  text-align: left;
}
.otpQr > div a {
  white-space: wrap;
}
.otpQr > div a:hover{
  color: #000;
}

.useBottom {margin-top: 15px;padding: 0px 13px;border: 1px solid #8f8faa;border-radius: 2px;}
#venderModal {width: 80%; top: 5%; height: 700px; overflow-y: scroll; }
#venderModal .modal-close{
  font-size: 30px;
  top: -20px;
}
#venderModal .btn-blue {
  background: #126ae2;
  color: #fff;
}
#uiWrap {
  position: relative;
}
#venderModal .sub-title{
  font-weight: bold;
}
#venderModal .rightbtn {
  position: absolute;
  right: 0;
  top: 20px;
  padding: 5px 10px;
}
/* popupTable */
.popupTable {
  width: 100%;
  text-align: center;
  vertical-align: middle;
  font-size: 14px;
  overflow: hidden;
}
.popupTable thead > tr {
  border: 1px solid #333;
}
.popupTable thead th {
  height: 40px;
  background: #353535;
  color: #fff;
  vertical-align: middle;
  font-size: 14px;
  box-sizing: border-box;
}
.popupTable .tablebodyWrap > tr {
  border: 1px solid #333;
}
.popupTable .tablebodyWrap > tr > td {
  border-right: 1px solid #333;
  padding: 8px 0;
}
.createTable { width: 100%; }
.createTable tr {
  border-bottom: 1px solid #333;
}
.tablebodyWrap .select {
  color: #e76262;
  font-weight: bold;
}
.createTable tr:last-child {
  border-bottom: 0;
}
.createTable tr > td {
  padding: 5px 20px;
  height: 26px;
}
.createTable input[type="number"] {
  width: 50px;
  border-radius: 5px;
  border: 1px solid #b9b9b9;
  padding: 0 10px;
  box-sizing: border-box;
}
/* popupTable tab content */
#tabList {
  padding: 10px 20px 0;
  display: flex;
  gap: 5px;
}
#tabList li{
  padding: 5px 15px;
  font-size: 14px;
  cursor: pointer;
}
#tabList li.on {
  border-bottom: 3px solid #e76262;
  font-weight: bold;
}
.onlyBtn{
  padding: 2px 5px;
  background: #0c768a;
  color: #fff;
  border-radius: 5px;
  margin-right: 5px;
}
</style>
